import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = {
  key: 0,
  class: "caption-top visually-hidden"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["id", "colspan", "rowspan", "aria-sort"]
const _hoisted_5 = { class: "me-2" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["id", "aria-sort"]
const _hoisted_10 = { class: "me-2" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["headers"]
const _hoisted_16 = ["id", "headers", "rowspan"]
const _hoisted_17 = ["headers"]
const _hoisted_18 = ["headers"]
const _hoisted_19 = ["headers"]
const _hoisted_20 = { key: 3 }
const _hoisted_21 = ["colspan"]

import {ref, computed, useId} from "vue";
import {BTableColumn, BTableOptions} from "./BTable.types";


export default /*@__PURE__*/_defineComponent({
  __name: 'BTable',
  props: {
    items: { default: () => [] },
    columns: { default: () => [] as BTableColumn[] },
    showHeader: { type: Boolean, default: true },
    value: { default: () =>
            ({
                totalItemCount: 0,
                itemsPerPage: 1,
                page: 1,
                sortBy: [],
            } as BTableOptions) },
    caption: { default: "" },
    tableStyle: { default: "" }
  },
  emits: ["optionChange"],
  setup(__props: any, { emit: __emit }) {

const tableId = useId();

const props = __props;

const tableOptions = ref(props.value as BTableOptions);
const emit = __emit;

function hasChildren(col: BTableColumn): boolean {
    return !!(col.children && col.children.length > 0);
}

const hasChildColumns = computed(() => props.columns.some(hasChildren));

const totalColumnCount = computed(() =>
    props.columns.reduce((sum, col) => sum + (hasChildren(col) ? col.children!.length : 1), 0)
);

function getSubRows(item: any): any[] {
    const parent = props.columns.find(hasChildren);
    if (!parent) return [];
    if (parent.subRows) return parent.subRows(item) ?? [];
    const v = parent.value ? parent.value(item) : null;
    return Array.isArray(v) ? v : [];
}

function isAscending(column: BTableColumn): boolean {
    const s = tableOptions.value.sortBy[0];
    return s && s.key == column.key && !s.isDescending;
}

function isDescending(column: BTableColumn): boolean {
    const s = tableOptions.value.sortBy[0];
    return s && s.key == column.key && s.isDescending;
}

function ariaSort(column: BTableColumn): "ascending" | "descending" | "none" | undefined {
    if (!column.sortable) return undefined;
    if (isAscending(column)) return "ascending";
    if (isDescending(column)) return "descending";
    return "none";
}

function onColumnClick(column: BTableColumn) {
    const s = tableOptions.value.sortBy[0];

    if (s && s.key == column.key) {
        if (s.isDescending) {
            tableOptions.value.sortBy = [];
        } else {
            tableOptions.value.sortBy[0].isDescending = true;
        }
    } else {
        tableOptions.value.sortBy = [
            {
                key: column.key,
                isDescending: false,
            },
        ];
    }
    tableOptions.value.page = 1;

    emit("optionChange", tableOptions.value);
}

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", {
      class: _normalizeClass(["table table-light b-table", {'table-striped': !hasChildColumns.value}]),
      style: _normalizeStyle(__props.tableStyle)
    }, [
      (__props.caption != '')
        ? (_openBlock(), _createElementBlock("caption", _hoisted_2, _toDisplayString(__props.caption), 1))
        : _createCommentVNode("", true),
      (__props.showHeader)
        ? (_openBlock(), _createElementBlock("thead", _hoisted_3, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: column.key,
                  id: `${_unref(tableId)}-col-${column.key}`,
                  style: _normalizeStyle(column.columnStyle || {}),
                  class: _normalizeClass(column.columnClass || []),
                  colspan: hasChildren(column) ? column.children!.length : 1,
                  rowspan: hasChildren(column) ? 1 : hasChildColumns.value ? 2 : 1,
                  "aria-sort": ariaSort(column)
                }, [
                  _renderSlot(_ctx.$slots, `header.${column.key}`, { column: column }, () => [
                    _createElementVNode("div", _hoisted_5, [
                      (column.sortable)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (onColumnClick(column)),
                              class: "btn btn-link link-dark p-0 border-0 align-baseline fw-bold text-nowrap"
                            }, _toDisplayString(column.text), 9, _hoisted_6),
                            _withDirectives(_createElementVNode("i", {
                              "aria-hidden": "true",
                              class: _normalizeClass(["bi bi-arrow-up position-absolute", isAscending(column) ? '' :'invisible'])
                            }, null, 2), [
                              [_directive_tooltip, 'Sorted asc']
                            ]),
                            _withDirectives(_createElementVNode("i", {
                              "aria-hidden": "true",
                              class: _normalizeClass(["bi bi-arrow-down position-absolute", isDescending(column) ? '' :'invisible'])
                            }, null, 2), [
                              [_directive_tooltip, 'Sorted desc']
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(column.text), 1))
                    ])
                  ]),
                  _renderSlot(_ctx.$slots, `header.bottom.${column.key}`, { column: column })
                ], 14, _hoisted_4))
              }), 128))
            ]),
            (hasChildColumns.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: column.key
                    }, [
                      (hasChildren(column))
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(column.children, (child) => {
                            return (_openBlock(), _createElementBlock("th", {
                              key: child.key,
                              id: `${_unref(tableId)}-col-${child.key}`,
                              style: _normalizeStyle(child.columnStyle || {}),
                              class: _normalizeClass(child.columnClass || []),
                              "aria-sort": ariaSort(child)
                            }, [
                              _renderSlot(_ctx.$slots, `header.${child.key}`, { column: child }, () => [
                                _createElementVNode("div", _hoisted_10, [
                                  (child.sortable)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        onClick: _withModifiers(($event: any) => (onColumnClick(child)), ["prevent"]),
                                        href: "",
                                        class: "link-dark"
                                      }, _toDisplayString(child.text), 9, _hoisted_11))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(child.text), 1)),
                                  _withDirectives(_createElementVNode("i", {
                                    "aria-hidden": "true",
                                    class: _normalizeClass(["bi bi-arrow-up position-absolute", isAscending(child) ? '' : 'invisible'])
                                  }, null, 2), [
                                    [_directive_tooltip, 'Sorted asc']
                                  ]),
                                  _withDirectives(_createElementVNode("i", {
                                    "aria-hidden": "true",
                                    class: _normalizeClass(["bi bi-arrow-down position-absolute", isDescending(child) ? '' : 'invisible'])
                                  }, null, 2), [
                                    [_directive_tooltip, 'Sorted desc']
                                  ])
                                ])
                              ])
                            ], 14, _hoisted_9))
                          }), 128))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (__props.items != null && __props.items.length > 0)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, itemIndex) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.id
              }, [
                (!hasChildColumns.value)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: column.key,
                          headers: `${_unref(tableId)}-col-${column.key}`,
                          style: _normalizeStyle(column.style ? column.style(item) : {}),
                          class: _normalizeClass([column.class ? column.class(item) : [], "align-middle"])
                        }, [
                          _renderSlot(_ctx.$slots, `cell.${column.key}`, {
                            column: column,
                            item: item
                          }, () => [
                            _createTextVNode(_toDisplayString(column.value ? column.value(item) : item), 1)
                          ])
                        ], 14, _hoisted_15))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSubRows(item), (subRow, subIdx) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: subIdx,
                          class: _normalizeClass({'b-table-group-striped': itemIndex % 2 === 0})
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: column.key
                            }, [
                              (!hasChildren(column) && subIdx === 0)
                                ? (_openBlock(), _createElementBlock("th", {
                                    key: 0,
                                    scope: "row",
                                    id: `${_unref(tableId)}-row-${itemIndex}`,
                                    headers: `${_unref(tableId)}-col-${column.key}`,
                                    rowspan: getSubRows(item).length || 1,
                                    style: _normalizeStyle(column.style ? column.style(item) : {}),
                                    class: _normalizeClass([[column.class ? column.class(item) : [], 'b-table-identity-header'], "align-middle"])
                                  }, [
                                    _renderSlot(_ctx.$slots, `cell.${column.key}`, {
                                      column: column,
                                      item: item
                                    }, () => [
                                      _createTextVNode(_toDisplayString(column.value ? column.value(item) : item), 1)
                                    ])
                                  ], 14, _hoisted_16))
                                : _createCommentVNode("", true),
                              (hasChildren(column))
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(column.children, (child) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      key: child.key,
                                      headers: `${_unref(tableId)}-col-${column.key} ${_unref(tableId)}-col-${child.key} ${_unref(tableId)}-row-${itemIndex}`,
                                      style: _normalizeStyle(child.style ? child.style(subRow) : {}),
                                      class: _normalizeClass([child.class ? child.class(subRow) : [], "align-middle"])
                                    }, [
                                      _renderSlot(_ctx.$slots, `cell.${child.key}`, {
                                        column: child,
                                        item: item,
                                        subRow: subRow
                                      }, () => [
                                        _createTextVNode(_toDisplayString(child.subRowValue
                                                        ? child.subRowValue(item, subRow)
                                                        : child.value
                                                        ? child.value(subRow)
                                                        : subRow), 1)
                                      ])
                                    ], 14, _hoisted_17))
                                  }), 128))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ], 2))
                      }), 128)),
                      (getSubRows(item).length === 0)
                        ? (_openBlock(), _createElementBlock("tr", {
                            key: 0,
                            class: _normalizeClass({'b-table-group-striped': itemIndex % 2 === 0})
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: column.key
                              }, [
                                (!hasChildren(column))
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 0,
                                      headers: `${_unref(tableId)}-col-${column.key}`,
                                      style: _normalizeStyle(column.style ? column.style(item) : {}),
                                      class: _normalizeClass([column.class ? column.class(item) : [], "align-middle"])
                                    }, [
                                      _renderSlot(_ctx.$slots, `cell.${column.key}`, {
                                        column: column,
                                        item: item
                                      }, () => [
                                        _createTextVNode(_toDisplayString(column.value ? column.value(item) : item), 1)
                                      ])
                                    ], 14, _hoisted_18))
                                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(column.children, (child) => {
                                      return (_openBlock(), _createElementBlock("td", {
                                        key: child.key,
                                        headers: `${_unref(tableId)}-col-${column.key} ${_unref(tableId)}-col-${child.key}`,
                                        class: "align-middle text-muted"
                                      }, null, 8, _hoisted_19))
                                    }), 128))
                              ], 64))
                            }), 128))
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 64))
              ], 64))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", {
                colspan: totalColumnCount.value,
                role: "status",
                "aria-live": "polite",
                "aria-atomic": "true"
              }, " No data to display at this time ", 8, _hoisted_21)
            ])
          ]))
    ], 6)
  ]))
}
}

})